export const InteractionButtonStyle = {
    borderRadius: 15
}